import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  page_content: null,
  loading: true,
  error: null,
  showLoadingScreen: false,
};

const baseUrl = process.env.REACT_APP_API;

export const fetchLoadingScreen = createAsyncThunk(
  "loadingScreen/fetchLoadingScreen",
  async (country) => {
    return fetch(`${baseUrl}/api/loading-page/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Accept-Language":
          country.language === "en" ? "en-UK" : country.language,
      },
    }).then((res) => errorStatusProvider(res));
  }
);

export const getLoadingScreen = (countryCode, language) => async (dispatch) => {
  const result = await dispatch(fetchLoadingScreen({ language }));

  const { responseStatus } = result.payload;

  dispatch(setShowServerErrorMessage(responseStatus));

  return result;
};

export const loadingScreenSlice = createSlice({
  name: "loadingScreen",
  initialState,
  reducers: {
    changeShowLoadingScreenState: (state, action) => {
      state.showLoadingScreen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoadingScreen.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLoadingScreen.fulfilled, (state, action) => {
        state.loading = false;
        state.page_content = action.payload.data.page_content;
      })
      .addCase(fetchLoadingScreen.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export const { changeShowLoadingScreenState } = loadingScreenSlice.actions;

export default loadingScreenSlice.reducer;
